import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Layer, Feature } from "react-mapbox-gl";
import _ from "lodash";

import markerIcons from "../config/markerIcons";

const getLabel = (m) => {
  if (m.isStartingLocation) {
    return "B";
  }
  if (m.isLastLocation) {
    return "E";
  }
  return m.number;
};

const MyMapBoxLayer = ({ layer, markers, onClick, type }) => {
  const setCursor = (map, cursor) => {
    map.getCanvas().style.cursor = cursor;
  };

  return (
    <Fragment>
      {markers.length > 0 && (
        <Layer key={type} {...layer.icon(type, markerIcons[type])}>
          {_.map(markers, (m, i) => (
            <Feature
              key={i}
              coordinates={[m.lng, m.lat]}
              properties={{ label: getLabel(m), color: `#${m.color}` }}
              onClick={() => onClick(m)}
              onMouseEnter={({ map }) => {
                setCursor(map, "pointer");
              }}
              onMouseLeave={({ map }) => {
                setCursor(map, "");
              }}
            />
          ))}
        </Layer>
      )}
    </Fragment>
  );
};

MyMapBoxLayer.propTypes = {
  layer: PropTypes.object.isRequired,
  markers: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default React.memo(MyMapBoxLayer);
